(function () {
  var KEY = 'novsix-wishlist';
  function get() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function save(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} paintCount(); }
  function has(h) { return get().indexOf(h) > -1; }
  function toggle(h) { var a = get(), i = a.indexOf(h); if (i > -1) a.splice(i, 1); else a.unshift(h); save(a); }
  function paintCount() {
    var n = get().length;
    document.querySelectorAll('[data-wish-count]').forEach(function (e) { e.textContent = n; e.hidden = n === 0; });
  }
  function paintButtons() {
    document.querySelectorAll('[data-wish]').forEach(function (b) {
      var on = has(b.getAttribute('data-wish'));
      b.classList.toggle('on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Save to wishlist');
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    toggle(b.getAttribute('data-wish'));
    paintButtons();
    if (window.__wishRender) window.__wishRender();
  });
  // expose the API BEFORE init(): the script is deferred, so init() runs synchronously and
  // the wishlist page's __wishRender() checks window.__wish — it must already exist.
  window.__wish = { get: get, has: has, paintCount: paintCount, paintButtons: paintButtons };
  function init() { paintButtons(); paintCount(); if (window.__wishRender) window.__wishRender(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();